<ng-content select="[start]" />

@if (organization().logoUrl) {
	<img
		class="organization-row__logo"
		[src]="organization().logoUrl"
		[alt]="organization().name"
	/>
} @else {
	<div class="organization-row__placeholder">
		<tui-icon icon="@tui.building" />
	</div>
}

<div class="organization-row__information">
	<p class="m-0 font-size-medium">{{ organization().name }}</p>
	<small>ID: {{ organization().id }}</small>
</div>

@if (interactable()) {
	<tui-icon icon="@tui.arrow-right" class="organization-row__chevron" />
}
